import React from "react";

import {
  Button,
  Content,
  Grid,
  GridItem,
  Hero,
  PageSection,
  Stack,
  StackItem
} from "@patternfly/react-core";
import "./EducationDirectionCallToAction.css";
import {
  ArrowRightIcon,
  ExternalLinkAltIcon
} from "@patternfly/react-icons";

import {
  Link
} from "react-router-dom";


const EducationDirectionAction = ({
  action
}) => {
  if (!action?.label) {
    return null;
  }

  if (action.to) {
    return (
      <Button
        component={Link}
        to={action.to}
        variant="primary"
        icon={<ArrowRightIcon />}
        iconPosition="end"
      >
        {action.label}
      </Button>
    );
  }

  if (action.href) {
    return (
      <Button
        component="a"
        href={action.href}
        target={
          action.external
            ? "_blank"
            : undefined
        }
        rel={
          action.external
            ? "noopener noreferrer"
            : undefined
        }
        variant="primary"
        icon={
          action.external
            ? <ExternalLinkAltIcon />
            : <ArrowRightIcon />
        }
        iconPosition="end"
      >
        {action.label}
      </Button>
    );
  }

  return null;
};

const EducationDirectionCallToAction = ({
  callToAction = {},
  image: selectedImage
}) => {
  const image =
  selectedImage?.src ??
  selectedImage ??
  null;
  
  const {
    title,
    description,
    primaryAction
  } = callToAction;

  if (!title && !description && !primaryAction) {
    return null;
  }

  return (
    <Hero
      className="education-direction-cta"
      isGlass
      bodyWidth="100%"
      bodyMaxWidth="100%"
      gradientLight={{
        stop1: "rgb(235, 242, 255)",
        stop2: "rgb(225, 235, 255)",
        stop3: "rgb(210, 225, 255)"
      }}
      gradientDark={{
        stop1: "rgb(8, 13, 31)",
        stop2: "rgb(15, 25, 55)",
        stop3: "rgb(22, 34, 77)"
      }}
    >
      {image && (
        <div
          className="education-direction-cta__image"
          style={{
            backgroundImage: `url("${image}")`
          }}
          aria-hidden="true"
        />
      )}

      <PageSection
        className="education-direction-cta__content"
        isWidthLimited
      >
        <Grid>
          <GridItem
            span={12}
            md={8}
            mdOffset={2}
          >
            <Stack
              hasGutter
              style={{
                textAlign: "center"
              }}
            >
              {(title || description) && (
                <StackItem>
                  <Content>
                    {title && (
                      <h2>{title}</h2>
                    )}

                    {description && (
                      <p>{description}</p>
                    )}
                  </Content>
                </StackItem>
              )}

              {primaryAction && (
                <StackItem>
                  <EducationDirectionAction
                    action={primaryAction}
                  />
                </StackItem>
              )}
            </Stack>
          </GridItem>
        </Grid>
      </PageSection>
    </Hero>
  );
};

export default EducationDirectionCallToAction;